/*
Author: Shivakumar
Date: 04/12//2019
issue: PL-1973: [Onboarding V1.1][Organisation] In Org Screen Profile Pop up Alignment issue
search_string: PL-1973
*/
/*
Author: Shivakumar
Date: 31/03//2020
issue: PL-1973:  Summary Screen Getting Error "TypeError: Cannot read property 'data' of undefined".
search_string: PL_3000
*/
<template>
  <div>
    <v-toolbar flat class="toolbar">
      <v-menu>
        <v-toolbar-title class="green-title" slot="activator" @click="gotoSummary">
          <span>{{brandName}}</span>
        </v-toolbar-title>
      </v-menu>
      <onboarding-progressbar class="progress-bar" value="12"></onboarding-progressbar>
      <v-spacer />
      <v-divider vertical></v-divider>
      <v-spacer />
      <div class="links">
        <span class="cursor" @click="clickedOnImage()">
          <img src="@/assets/user@2x.png" class="img-user-account" />
          <div class="entity-container">
             <!-- Here added css for signout box By Bhushan -->
            <div class="signout-block">
              <img  class="user-block" src="@/assets/emplogopic.svg" />
              <div class="information-user">
                <span class="user-text">{{name}}</span>
                <br />
                <span class="user-text">{{email}}</span>
              </div>
            </div>
            <!-- End here -->
            <div class="btn-container2">
              <!-- <button class="btn-add-entity" @click="$router.push('/onboarding/legal_entities/addLegalEntity')">Add Legal Entity</button> -->
              <div class="btn-signout" @click="signout()">Signout</div>
            </div>
          </div>
        </span>
      </div>
      <v-spacer />
      <div></div>
    </v-toolbar>
    <pop-up-message
      v-if="showConfirmDelete"
      :message="'Are you sure want to Signout ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Signout'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="confirmSignout()">Signout</button>
        </div>
      </template>
    </pop-up-message>
  </div>
</template>

<script>
import OnboardingProgressbar from "./OnboardingProgressbar.vue";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "onboardingToolbar",
  props: ["brandName", "backLinkUrl"],//PL_3000
  components: {
    OnboardingProgressbar
  },
  data() {
    return {
      toast: false,
      errmsg: "",
      showEntitiesContainer: false,
      showConfirmDelete: false,
      popupType: "ConfirmDelete"
    };
  },
  computed: {
    ...mapState({
      name: state => state.auth.name,
      email: state => state.auth.email,
    }),
  },
  methods: {
    ...mapActions({
      act_signOut: "auth/signOut",
      act_fetchle: "onboard/legal_entities/fetchAll"
    }),

    clickedOnImage() {
      this.showEntitiesContainer = !this.showEntitiesContainer;
    },

    cancelEvent() {
      this.showConfirmDelete = false;
    },

    signout() {
      this.showEntitiesContainer = !this.showEntitiesContainer;
      this.showConfirmDelete = true;
    },
    // PL_3000
    gotoSummary() {
      if (this.backLinkUrl) {
        this.$router.push(`${this.backLinkUrl}`);
      } else {
        this.$router.push("/orgsummary");
      }
    },
    // PL_3000
    async confirmSignout() {
      try {
        let res = await this.act_signOut();
        if (res.status) {
          this.showConfirmDelete = false;
          this.$router.push({
            path: `/signin`
          });
          window.localStorage.clear();
          localStorage.removeItem("heartBeat")
          window.location.reload()
          window.sessionStorage.clear();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
      this.showConfirmDelete = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/dashboard/_variables.scss"; // variables
@import "@/scss/dashboard/_header.scss"; // Header

.entity-container {
  background-color: white;
  z-index: 10;
  width: 350px;
  // width: 300px;
  height: 165px;
  box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.15);
  border: solid 0.8px #c6c9c8;
  position: fixed;
  right: 95px;
  top: 50px;
  &::before {
    bottom: 100%;
    right: 10%;
    border: 0.8px solid #c6c9c8;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: transparent;
    border-bottom-color: $color-white;
    border-width: 21px 10px 21px 10px;
  }
  .entity-list {
    height: 70%;
    overflow-y: scroll;
    scrollbar-color: black;
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
      height: 50px;
      background-color: #666;
      border: 1px solid #eee;
      -webkit-border-radius: 6px;
    }
    .entity {
      padding: 20px;
      display: flex;
      align-items: center;
      &:not(:first-child) {
        background-color: #f9f9f9;
      }
      &:first-child {
        background-color: $color-white;
        padding: 30px;
      }
      &:not(:last-child) {
        border-bottom: solid 0.8px #c6c9c8;
      }
      .entity-img {
        height: 60px;
        width: 60px;
        border-radius: 50%;
        margin-right: 20px;
      }
      .entity-text {
        text-align: center;
      }
    }
  }
}

.links {
  cursor: pointer;
  .entity-container {
    display: none;
  }
  &:hover {
    .entity-container {
      display: block;
    }
  }
}

.btn-container2 {
  border-top: solid 0.8px #c6c9c8;
  position: absolute;
  width: 100%;
  bottom: 0px;
  display: flex;
  justify-content: center;
  padding: 15px;
  *:nth-child(n) {
    margin-right: 20px;
  }
  .btn-add-entity {
    background-color: $color-primary;
    color: $color-white;
    min-width: 70px;
    border-radius: 4px;
    height: 30px;
    font-size: 12px;
    padding: 5px 10px 5px 10px;
  }
  .btn-signout {
    font-size: 12px;
    padding: 5px;
    font-weight: bold;
    color: $color-secondary;
    cursor: pointer;
  }
}

.toolbar {
  background-color: white;
  border-bottom: 2px solid #ebebeb;
  position: fixed;
  z-index: 1;
}
.progress-bar {
  margin: 0 50px 0 150px;
  width: 60%;
  visibility: hidden;
}
.img-user-account {
  width: 33px;
  width: 33px;
  height: 33px;
  object-fit: contain;
}
.green-title {
  color: #34c0be;
  font-weight: bolder;
}

// Start PL-1973
@media only screen and (min-width: 1281px) and (max-width: 1440px) {
  .entity-container {
    right: 32px;
    z-index: 2;
    top: 50px;
  }
}

@media only screen and (max-width: 1280px) {
  .entity-container {
    right: 15px;
    top: 50px;
    z-index: 2;
  }
}

// End PL-1973


// Here added css for signout box By Bhushan
.signout-block {
  padding: 5px 10px;
  margin-top: 18px;
}

img.user-block {
  width: 40px;
  margin-right: 10px;
}

.information-user {
  display: inline;
  position: absolute;
  margin: 0px 10px 0px 0px;
}

.user-text {
  word-break: break-all;
  overflow-wrap: break-word;
}
</style>
